import styled from "styled-components";

export const Path = styled.path`
    stroke: ${(props) => props.color};
`;

export const Icon = styled.svg`
    fill: none;

    ${Path} {
        stroke: ${(props) => props.color};
    }

    &:hover {
        ${Path} {
            stroke: ${(props) =>
                props.hover ? props.hoverColor : props.color};
        }
    }
`;
